import { render } from "./HODashboard.vue?vue&type=template&id=358939bb&scoped=true"
import script from "./HODashboard.vue?vue&type=script&lang=js"
export * from "./HODashboard.vue?vue&type=script&lang=js"

import "./HODashboard.vue?vue&type=style&index=0&id=358939bb&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358939bb"]])

export default __exports__